
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import Table from 'react-bootstrap/lib/Table';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Save, Loader2, Share2, RefreshCw, Activity, Layers } from 'lucide-react';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import submit from './submit';
import s from '../SiteSettingsForm/SiteSettingsForm.css'; // Reuse styles
import cp from '../../../components/commonStyle.css';

class SocialMediaSettingsForm extends Component {

    static propTypes = {
        initialValues: PropTypes.object,
        title: PropTypes.string.isRequired,
        socialInfo: PropTypes.shape({
            channels: PropTypes.array,
            logs: PropTypes.array
        }),
        change: PropTypes.func.isRequired
    };

    static defaultProps = {
        socialInfo: { channels: [], logs: [] }
    };

    constructor(props) {
        super(props);
        this.state = {
            activeChannels: []
        };
    }

    componentDidMount() {
        // Initialize active channels state from initialValues
        if (this.props.initialValues && this.props.initialValues.social_active_channels) {
            try {
                const parsed = JSON.parse(this.props.initialValues.social_active_channels);
                this.setState({ activeChannels: parsed });
            } catch (e) {
                console.error("Failed to parse social_active_channels", e);
            }
        }
    }

    handleChannelToggle = (channelId) => {
        const { activeChannels } = this.state;
        let newChannels;

        if (activeChannels.includes(channelId)) {
            newChannels = activeChannels.filter(id => id !== channelId);
        } else {
            newChannels = [...activeChannels, channelId];
        }

        this.setState({ activeChannels: newChannels });

        // Update the hidden redux-form field
        this.props.change('social_active_channels', JSON.stringify(newChannels));
    }

    handleRefreshChannels = () => {
        window.location.reload();
    }

    render() {
        const { error, handleSubmit, submitting, socialInfo } = this.props;
        const { activeChannels } = this.state;

        return (
            <div className={cx(cp.adminContentPadding)}>
                <h1 className={cx(s.headerTitle, s.marginTop0)}>
                    <Share2 size={28} className={s.icon} /> Social Media Automation
                </h1>
                <p className={s.headerSubtitle}>
                    Configure el Agente IA, gestione los canales conectados y audite la actividad.
                </p>

                <form onSubmit={handleSubmit(submit)}>
                    {error && <strong>{error}</strong>}

                    {/* Hidden Field for Active Channels */}
                    <Field name="social_active_channels" component="input" type="hidden" />

                    <Tabs defaultActiveKey={1} id="social-media-tabs" animation={false} className={s.adminTabs}>

                        {/* TAB 1: CONFIGURATION */}
                        <Tab eventKey={1} title={<span><Layers size={16} /> Configuración</span>}>
                            <div className={s.tabContent}>
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup className={cx(s.spaceTop3, cp.noMarginBottom)}>
                                            <ControlLabel className={cx(cp.adminLableTextNew, s.marginTop0, s.marginBottom9)}>
                                                Estado de Automatización
                                            </ControlLabel>
                                            <Field name="social_automation_enabled" component={CommonFormComponent} inputClass={cx(s.formControlSelect, cp.formControlSelect)} type="select">
                                                <option value="false">Desactivado</option>
                                                <option value="true">Activado</option>
                                            </Field>
                                        </FormGroup>
                                    </Col>

                                    <Col xs={12}>
                                        <FormGroup className={cx(s.spaceTop3, cp.noMarginBottom)}>
                                            <ControlLabel className={cx(cp.adminLableTextNew, s.marginTop0, s.marginBottom9)}>
                                                Prompt del Sistema
                                            </ControlLabel>
                                            <Field
                                                name="social_automation_prompt"
                                                component={CommonFormComponent}
                                                componentClass="textarea"
                                                rows={4}
                                                placeholder="Ej: Escribe un post atractivo..."
                                                inputClass={cx(cp.adminFormControlInput)}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col xs={12}>
                                        <FormGroup className={cx(s.spaceTop3, cp.noMarginBottom)}>
                                            <ControlLabel className={cx(cp.adminLableTextNew, s.marginTop0, s.marginBottom9)}>
                                                Prompt de Generación de Video (Veo 3.1)
                                            </ControlLabel>
                                            <Field
                                                name="social_video_prompt"
                                                component={CommonFormComponent}
                                                componentClass="textarea"
                                                rows={3}
                                                placeholder="Ej: Cinematic luxury yacht promotional video. A stunning {boatName} glides through crystal clear waters..."
                                                inputClass={cx(cp.adminFormControlInput)}
                                            />
                                            <p className="help-block">
                                                Variables disponibles: {'{boatName}'}, {'{location}'}, {'{price}'}.
                                                Deje vacío para usar el prompt por defecto.
                                            </p>
                                        </FormGroup>
                                    </Col>

                                    <Col xs={12}>
                                        <FormGroup className={cx(s.spaceTop3, cp.noMarginBottom)}>
                                            <ControlLabel className={cx(cp.adminLableTextNew, s.marginTop0, s.marginBottom9)}>
                                                Postiz API Key
                                            </ControlLabel>
                                            <Field
                                                name="social_postiz_api_key"
                                                component={CommonFormComponent}
                                                type="password"
                                                placeholder="sk-..."
                                                inputClass={cx(cp.adminFormControlInput)}
                                            />
                                            <p className="help-block">Requerido para conectar con Postiz.</p>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </Tab>

                        {/* TAB 2: CHANNELS */}
                        <Tab eventKey={2} title={<span><Share2 size={16} /> Canales</span>}>
                            <div className={s.tabContent}>
                                <div className={s.spaceTop3}>
                                    <div className="pull-right">
                                        <Button bsStyle="info" bsSize="small" onClick={this.handleRefreshChannels}>
                                            <RefreshCw size={14} /> Sincronizar desde Postiz
                                        </Button>
                                    </div>
                                    <h4 className={s.marginTop0}>Canales Conectados</h4>
                                    <p className="help-block">Selecciona los canales donde quieres que el Agente publique automáticamente.</p>

                                    <hr />

                                    {socialInfo.channels && socialInfo.channels.length > 0 ? (
                                        <Row>
                                            {socialInfo.channels.map(channel => (
                                                <Col xs={12} sm={6} md={4} key={channel.id}>
                                                    <div className={s.channelCard} style={{
                                                        border: '1px solid #eee',
                                                        padding: '15px',
                                                        marginBottom: '15px',
                                                        borderRadius: '5px',
                                                        backgroundColor: activeChannels.includes(channel.id) ? '#f0f9ff' : '#fff'
                                                    }}>
                                                        <Checkbox
                                                            checked={activeChannels.includes(channel.id)}
                                                            onChange={() => this.handleChannelToggle(channel.id)}
                                                        >
                                                            <strong>{channel.provider}</strong>
                                                            <div className="text-muted small">{channel.name}</div>
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>
                                    ) : (
                                        <div className="alert alert-warning">
                                            No se detectaron canales en Postiz. Asegúrate de configurar las integraciones en tu instancia de Postiz y verificar la API Key.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Tab>

                        {/* TAB 3: LOGS */}
                        <Tab eventKey={3} title={<span><Activity size={16} /> Logs</span>}>
                            <div className={s.tabContent}>
                                <h4 className={s.spaceTop3}>Actividad Reciente</h4>
                                <Table striped bordered condensed hover className={s.marginTop2}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '180px' }}>Fecha</th>
                                            <th style={{ width: '100px' }}>Tipo</th>
                                            <th>Mensaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {socialInfo.logs && socialInfo.logs.length > 0 ? (
                                            socialInfo.logs.map((log, index) => (
                                                <tr key={index}>
                                                    <td>{log.timestamp ? new Date(log.timestamp).toLocaleString() : '-'}</td>
                                                    <td>
                                                        <span className={cx('label', {
                                                            'label-success': log.type === 'SUCCESS',
                                                            'label-danger': log.type === 'ERROR',
                                                            'label-warning': log.type === 'WARN',
                                                            'label-info': log.type === 'INFO' || !log.type
                                                        })}>
                                                            {log.type || 'INFO'}
                                                        </span>
                                                    </td>
                                                    <td>{log.message}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">No hay actividad registrada aún.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Tab>
                    </Tabs>

                    <Row>
                        <Col xs={12} className={cx(cp.textAlignRight, cp.spaceTop5)}>
                            <Button className={cx(cp.btnPrimary, cp.btnlarge)} type="submit" disabled={submitting}>
                                {submitting ? <Loader2 size={18} className="spin" /> : <Save size={18} />}
                                {' '}Guardar Configuración
                            </Button>
                        </Col>
                    </Row>

                </form>
            </div>
        );
    }
}

SocialMediaSettingsForm = reduxForm({
    form: 'SocialMediaSettingsForm',
})(SocialMediaSettingsForm);

export default withStyles(s, cp)(SocialMediaSettingsForm);
